import React from 'react';

interface AdminPageHeaderProps {
  eyebrow: string;
  title: string;
  description: string;
  actions?: React.ReactNode;
}

const AdminPageHeader: React.FC<AdminPageHeaderProps> = ({ eyebrow, title, description, actions }) => (
  <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
    <div>
      <div className="text-[11px] uppercase tracking-[0.4em] text-amber-100/45">{eyebrow}</div>
      <h1 className="mt-3 font-heading text-4xl font-semibold text-white">{title}</h1>
      <p className="mt-3 max-w-3xl text-sm leading-7 text-white/55">{description}</p>
    </div>
    {actions && <div className="flex flex-wrap gap-3">{actions}</div>}
  </div>
);

export default AdminPageHeader;

